import { get } from 'lodash'

export const hasAtLeastOneCoach = students => {
  let hasCoach = false
  students.forEach(({ coaches }) => {
    if (coaches && coaches.length) {
      hasCoach = true
      return hasCoach
    }
  })
  return hasCoach
}

const countActiveOfferings = lessonTypes =>
  (lessonTypes || []).filter(
    ({ status, deletedAt }) => status === 'ACTIVE' && !deletedAt,
  ).length

const flattenCoaches = coaches =>
  coaches.reduce((acc, cv) => {
    const facility = get(cv, ['coachProfile', 'facilities', '0'], {})
    acc.push({
      id: cv.id,
      externalId: cv.externalId,
      name: cv.name,
      coachAvatar: get(cv, 'coachProfile.profilePhoto', null),
      coachSlug: get(cv, ['coachProfile', 'slug']),
      facilityName: facility.facilityName || null,
      city: facility.city || null,
      state: facility.state || null,
      offeringsCount: countActiveOfferings(cv.lessonTypes),
    })
    return acc
  }, [])

export const parseData = representatives =>
  representatives.reduce((acc, cv) => {
    const { id, firstName, lastName, coaches } = cv.student
    acc.push({
      id: id,
      relationshipType: cv.relationshipType,
      firstName,
      lastName,
      coaches: flattenCoaches(coaches),
    })
    return acc
  }, [])

export const getStudentPickerLabel = ({ relationshipType, firstName }) =>
  relationshipType === 'SELF' ? 'Me' : firstName
